// Recovered compiled webpack factory 51290. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, {
    Bk: () => k,
    CC: () => _,
    Ck: () => y,
    G_: () => E,
    Hu: () => A,
    Qh: () => b,
    VS: () => C,
    aO: () => m,
    cI: () => P,
    et: () => O,
    kX: () => v,
    pK: () => T,
    uU: () => R,
    xO: () => M,
    xl: () => I,
    yW: () => w,
    zU: () => N,
  });
  var n = r(76636),
    a = r(60057),
    o = r(2257),
    i = r(88722),
    s = r(13590),
    l = r(20753),
    u = r(73314),
    c = r(17588),
    f = r(87624),
    d = r(64189),
    p = r(43275),
    h = r(43316);
  let _ = 0,
    m = 1,
    g = !1;
  function y(e) {
    let { spanId: t, traceId: r } = e.spanContext(),
      { data: n, op: a, parent_span_id: o, status: i, origin: s, links: l } = O(e);
    return {
      parent_span_id: o,
      span_id: t,
      trace_id: r,
      data: n,
      op: a,
      status: i,
      origin: s,
      links: l,
    };
  }
  function v(e) {
    let { spanId: t, traceId: r, isRemote: n } = e.spanContext(),
      a = n ? t : O(e).parent_span_id,
      o = (0, l.L)(e).scope;
    return {
      parent_span_id: a,
      span_id: n ? o?.getPropagationContext().propagationSpanId || (0, c.Z)() : t,
      trace_id: r,
    };
  }
  function b(e) {
    let { traceId: t, spanId: r } = e.spanContext(),
      n = T(e);
    return (0, d.TC)(t, r, n);
  }
  function E(e) {
    let { traceId: t, spanId: r } = e.spanContext(),
      n = T(e);
    return (0, d.Iy)(t, r, n);
  }
  function R(e) {
    return e && e.length > 0
      ? e.map(({ context: { spanId: e, traceId: t, traceFlags: r, ...n }, attributes: a }) => ({
          span_id: e,
          trace_id: t,
          sampled: r === m,
          attributes: a,
          ...n,
        }))
      : void 0;
  }
  function P(e) {
    return "number" == typeof e
      ? S(e)
      : Array.isArray(e)
        ? e[0] + e[1] / 1e9
        : e instanceof Date
          ? S(e.getTime())
          : (0, f.zf)();
  }
  function S(e) {
    return e > 0x2540be3ff ? e / 1e3 : e;
  }
  function O(e) {
    var t;
    if ("function" == typeof e.getSpanJSON) return e.getSpanJSON();
    let { spanId: r, traceId: n } = e.spanContext();
    if ((t = e).attributes && t.startTime && t.name && t.endTime && t.status) {
      let { attributes: t, startTime: a, name: o, endTime: s, status: l, links: u } = e;
      return {
        span_id: r,
        trace_id: n,
        data: t,
        description: o,
        parent_span_id:
          "parentSpanId" in e
            ? e.parentSpanId
            : "parentSpanContext" in e
              ? e.parentSpanContext?.spanId
              : void 0,
        start_timestamp: P(a),
        timestamp: P(s) || void 0,
        status: w(l),
        op: t[i.uT],
        origin: t[i.JD],
        links: R(u),
      };
    }
    return { span_id: r, trace_id: n, start_timestamp: 0, data: {} };
  }
  function T(e) {
    let { traceFlags: t } = e.spanContext();
    return t === m;
  }
  function w(e) {
    if (e && e.code !== s.a3) return e.code === s.F3 ? "ok" : e.message || "internal_error";
  }
  let j = "_sentryChildSpans",
    x = "_sentryRootSpan";
  function A(e, t) {
    let r = e[x] || e;
    ((0, u.my)(t, x, r), e[j] ? e[j].add(t) : (0, u.my)(e, j, new Set([t])));
  }
  function C(e, t) {
    e[j] && e[j].delete(t);
  }
  function M(e) {
    let t = new Set();
    return (
      !(function e(r) {
        if (!t.has(r) && T(r)) for (let n of (t.add(r), r[j] ? Array.from(r[j]) : [])) e(n);
      })(e),
      Array.from(t)
    );
  }
  function N(e) {
    return e[x] || e;
  }
  function k() {
    let e = (0, a.EU)(),
      t = (0, n.h)(e);
    return t.getActiveSpan ? t.getActiveSpan() : (0, h.f)((0, o.o5)());
  }
  function I() {
    g ||
      ((0, p.pq)(() => {
        console.warn(
          "[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly or use `ignoreSpans`.",
        );
      }),
      (g = !0));
  }
}
